import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { WizardSubstep } from "../../../common/wizard/wizard-subtep.interface";
import { ChannelCodec } from "../../../../domain/channel-codec";
import {
  ChannelPlatformType,
  StreamingProtocol,
} from "../../../../domain/enums";
import {
  ChannelInfo,
  ChannelPlatform,
  ChannelPushMpgtsSettings,
  CustomChannelPlatform,
  FacebookChannelPlatform,
  MyAppChannelPlatform,
  MyWebsiteChannelPlatform,
  YoutubeChannelPlatform,
} from "../../../../domain/channel";
import { Font } from "../../../../domain/font";
import { UserService } from "../../../../domain/user-service";
import { EdgeServer } from "../../../../domain/edge-server";

@Component({
  selector: "icn-channel-wizard-step2-substep1",
  templateUrl: "./substep1.html",
  styleUrls: ["./substep1.scss"],
})
export class ChannelWizardStep2Substep1Component
  implements WizardSubstep, OnInit
{
  constructor(private userService: UserService) {}
  @Input() allEdgeServers: EdgeServer[];
  @Input() channelCodecs: ChannelCodec[] = [];
  @Input() channelPlatforms: ChannelPlatform[];
  @Input() burnSubtitlesToVideo: boolean;
  @Input() channelInfo: ChannelInfo;
  @Output() saveCodec = new EventEmitter<ChannelCodec>();

  relevantFeedPreviewEdgeServers: EdgeServer[];
  allSystemEdgeServers: EdgeServer[];
  selectedPlatformType: ChannelPlatformType;
  HlsOrPush = "Hls";
  fonts: Font[];

  onSelectPlatform(platformType) {
    platformType === 6
      ? ((this.selectedPlatformType = platformType - 1),
        (this.HlsOrPush = "Push"))
      : ((this.selectedPlatformType = platformType), (this.HlsOrPush = "Hls"));
  }

  addPlatform() {
    if (!this.selectedPlatformType) {
      return;
    }

    if (this.selectedPlatformType === ChannelPlatformType.Facebook) {
      this.channelPlatforms.push(new FacebookChannelPlatform(-1, true));
    } else if (this.selectedPlatformType === ChannelPlatformType.Youtube) {
      this.channelPlatforms.push(new YoutubeChannelPlatform(-1, true));
    } else if (this.selectedPlatformType === ChannelPlatformType.MyApp) {
      this.channelPlatforms.push(new MyAppChannelPlatform(-1, true));
    } else if (this.selectedPlatformType === ChannelPlatformType.MyWebsite) {
      this.channelPlatforms.push(new MyWebsiteChannelPlatform(-1, true));
    } else if (
      this.selectedPlatformType === ChannelPlatformType.Custom &&
      this.HlsOrPush === "Hls"
    ) {
      this.channelPlatforms.push(
        new CustomChannelPlatform(
          -1,
          true,
          "Untitled",
          StreamingProtocol.Hls,
          {
            resolution: 1080,
            fps: 25,
          },
          ChannelPushMpgtsSettings.DEFAULT(),
          ["en"],
          {
            en: {
              fontId: this.fonts[0].id,
              size: 12,
              subtitleStartPositionFromTop: 75,
              subtitleEndPositionFromTop: 90,
            },
          },
          [],
        ),
      );
    } else if (
      this.selectedPlatformType === ChannelPlatformType.Custom &&
      this.HlsOrPush === "Push"
    ) {
      this.channelPlatforms.push(
        new CustomChannelPlatform(
          -1,
          true,
          "Untitled",
          StreamingProtocol.Push,
          {
            resolution: 1080,
            fps: 25,
          },
          ChannelPushMpgtsSettings.DEFAULT(),
          ["en"],
          {
            en: {
              fontId: this.fonts[0].id,
              size: 12,
              subtitleStartPositionFromTop: 75,
              subtitleEndPositionFromTop: 90,
            },
          },
          [],
        ),
      );
    }
  }

  canGoNext() {
    return this.channelPlatforms && this.checkAudioLanguages();
  }

  checkAudioLanguages() {
    for (let i = 0; i < this.channelPlatforms.length; i++) {
      if (this.channelPlatforms[i] instanceof CustomChannelPlatform) {
        const platform = this.channelPlatforms[i] as CustomChannelPlatform;
        if (platform.audioLanguages.length === 0) {
          return false;
        }
      }
    }
    return true;
  }

  onRemovePlatform(platform) {
    this.channelPlatforms.splice(this.channelPlatforms.indexOf(platform), 1);
  }

  isFacebookPlatform(channelPlatform: ChannelPlatform) {
    return channelPlatform.channelPlatformType === ChannelPlatformType.Facebook;
  }

  isCustomPlatform(channelPlatform: ChannelPlatform) {
    return channelPlatform.channelPlatformType === ChannelPlatformType.Custom;
  }

  ngOnInit() {
    const currentUser = this.userService.getCurrentUser();
    this.fonts = currentUser.fonts;
    this.allSystemEdgeServers = currentUser.systemEdgeServers;
    this._bindEdgePreviewServers();
  }
  public _bindEdgePreviewServers() {
    const currentUser = this.userService.getCurrentUser();
    const allEdgeServers = currentUser.systemEdgeServers;
    const relevantFeedPreviewEdgeServersIds = this.channelPlatforms
      .map((p) => p.edgeServerIds)
      .reduce((a, b) => a.concat(b));
    this.relevantFeedPreviewEdgeServers = allEdgeServers.filter((e) =>
      relevantFeedPreviewEdgeServersIds.includes(e.id),
    );
  }
}
